import React, { useState } from 'react';
import { CpuIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <nav className="fixed top-[37px] left-0 right-0 z-50 bg-white dark:bg-[#0E131F] border-b border-gray-200 dark:border-white/10 shadow-sm transition-colors duration-300" data-id="element-327" data-mp="x8ubxz8uve7j">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-328" data-mp="4kop96y8rf52">
        <div className="flex justify-between items-center h-24" data-id="element-329" data-mp="4nayrc4p04px">
          <div className="flex items-center gap-2" data-id="element-330" data-mp="ky2rffqzl6c">
            <Link to="/" className="flex items-center" data-id="element-331" data-mp="eje9v7hivdp0">
              <img src="https://cdn.magicpatterns.com/uploads/wARv7Md6wddGeKdpXuv8BA/gemini-svg_(2).svg" alt="Effy Mobile" className="h-[68px] w-auto object-contain dark:bg-white dark:p-1.5 dark:rounded-lg transition-all" data-id="element-332" data-mp="ekz2grka0mk8" />
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-333" data-mp="1kzzrseesq6hu">
            <Link to="/shop" className="cricket-nav-link" data-id="element-334" data-mp="1l1ubxqi8tukv">
              Shop
            </Link>
            <Link to="/plans" className="cricket-nav-link" data-id="element-335" data-mp="9qu09tih7k1x">
              Plans
            </Link>
            <Link to="/business" className="cricket-nav-link" data-id="element-336" data-mp="epdnrycpx3we">
              Business
            </Link>
            <Link to="/coverage" className="cricket-nav-link" data-id="element-337" data-mp="jkt1mqaq6zst">
              Coverage
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4" data-id="element-338" data-mp="3n3m6mepfugbd">
            <button className="text-sm font-bold text-black dark:text-white hover:text-[#13E200] dark:hover:text-[#13E200] transition-colors uppercase tracking-wider" data-id="element-339" data-mp="3n19itkx01bqe">
              Sign In
            </button>
            <Link to="/signup" className="cricket-btn-primary !py-2 !px-6" data-id="element-340" data-mp="ub7qie5py5v">
              Join Effy
            </Link>
            <Link to="/dashboard" className="cricket-btn-secondary !py-2 !px-6" data-id="element-341" data-mp="34d4i6mbn26vt">
              Dashboard
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:flex hidden items-center" data-id="element-342" data-mp="399mk7efl3r4g" />
          <div className="md:hidden flex items-center" data-id="element-343" data-mp="319yqohorlube">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-black dark:text-white hover:text-[#13E200] transition-colors" data-id="element-344" data-mp="2wc6ql0dyv1w4">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-345" data-mp="361ghwe0zkgj6" /> : <MenuIcon className="w-6 h-6" data-id="element-346" data-mp="363b55yzqckqf" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white dark:bg-[#0E131F] border-b border-gray-200 dark:border-white/10 px-4 pt-2 pb-6 space-y-4 shadow-lg absolute w-full" data-id="element-347" data-mp="2dducr1c413u7">
          <Link to="/shop" className="block cricket-nav-link" onClick={() => setIsMobileMenuOpen(false)} data-id="element-348" data-mp="2s8iga9xy9s76">Shop</Link>
          <Link to="/plans" className="block cricket-nav-link" onClick={() => setIsMobileMenuOpen(false)} data-id="element-349" data-mp="7kcj9ryjwpid">Plans</Link>
          <Link to="/business" className="block cricket-nav-link" onClick={() => setIsMobileMenuOpen(false)} data-id="element-350" data-mp="2lsvdm0ed3nd">Business</Link>
          <Link to="/coverage" className="block cricket-nav-link" onClick={() => setIsMobileMenuOpen(false)} data-id="element-351" data-mp="a3qz19vwdkio">Coverage</Link>
          <div className="pt-4 flex flex-col gap-3" data-id="element-352" data-mp="f56nlbxaa95t">
            <button className="w-full text-sm font-bold text-black dark:text-white hover:text-[#13E200] transition-colors uppercase tracking-wider text-left" data-id="element-353" data-mp="14m1a5s5tv7k">
              Sign In
            </button>
            <Link to="/signup" className="w-full cricket-btn-primary !py-3 text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-354" data-mp="sus1i7w87y6z">
              Join Effy
            </Link>
            <Link to="/dashboard" className="w-full cricket-btn-secondary !py-3 text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-355" data-mp="k2ycry6jnh6b">
              Dashboard
            </Link>
          </div>
        </div>}
    </nav>;
}